import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Button, Grid, Chip, Divider } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"; // Icon for Start Date and End Date
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { GoDotFill } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { FaFilePdf, FaFileWord, FaFileAlt } from 'react-icons/fa';
import pdf from "./../../assets/images/service/pdf.png";
import word from "./../../assets/images/service/docs.png";
import { useDispatch, useSelector } from "react-redux";
import { getContractDetails } from "../../redux/slices/myAccount/contractDetailsSlice";
import Loading from "../../components/UI/Loading/Loading";
import { useParams } from "react-router-dom";
const ContractDetails = () => {
    const { translations, direction, language } = useLanguage();
    const dispatch = useDispatch();
    const { isLoggedIn, user, token } = useSelector(state => state.login);
    const t = translations;
    const location = useLocation();
    const navigate = useNavigate();
    const [downloadError, setDownloadError] = useState(false);
    const { id: paramContractId } = useParams();
    // Get contract from either location state or URL param
    const contract1 = location.state?.contract.contractId || paramContractId;
    // const contract1 = location.state?.contract;
    useEffect(() => {
        if (contract1 && token) {
            dispatch(getContractDetails({ contractId: contract1, token, language }));
        }
    }, [dispatch, contract1, token, language]);
    const { loading, contractDetails } = useSelector((state) => state.contractDetails);
    const contract = contractDetails?.message;
    const {
        title = contract?.contractNameLocalized,
        startDate = contract?.startDate ? new Date(contract.startDate).toLocaleDateString() : "N/A",
        endDate = contract?.endDate ? new Date(contract.endDate).toLocaleDateString() : "N/A",
        totalPrice = contract?.totalAmount || 0,
        unitInfo = [
            {
                name: contract?.equipmentVm?.equipmenNameLocalized || "N/A",
                description: contract?.equipmentVm?.descriptionNameLocalized || "N/A",
                project: contract?.equipmentVm?.projectName || "N/A",
                building: contract?.equipmentVm?.functionLocationName || "N/A",
                floor: contract?.equipmentVm?.floorNumber || 0,
                status: contract?.active ? "Active" : "Stopped",
            },
        ],
        fileName = "Contract_2020.pdf",
        fileSize = "456 KB",
    } = contract || {};
    const startDate2 = contract?.startDate ? new Date(contract.startDate).toLocaleDateString() : "N/A";
    const endDate2 = contract?.endDate ? new Date(contract.endDate).toLocaleDateString() : "N/A";
    const [baseURL, setBaseURL] = useState('');
    useEffect(() => {
        // Fetch the config.json to get the baseURL
        const fetchConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setBaseURL(config.baseURL);
            } catch (error) {
                // console.error('Error fetching config.json:', error);
            }
        };

        fetchConfig();
    }, []);

    const handleDownload = () => {
        if (contract?.attachment?.filePath) {
            const filePath = `${baseURL}/Upload${contract.attachment.filePath}`;

            // Fetch the image blob
            fetch(filePath)
                .then(response => response.blob()) // Get the image blob
                .then(blob => {
                    const link = document.createElement("a");
                    const objectURL = URL.createObjectURL(blob); // Create an object URL for the blob

                    link.href = objectURL;
                    link.download = contract.attachment.fileName || "contract"; // Use the file name or default
                    link.target = "_blank"; // Open in a new tab (optional)

                    // Trigger the download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Clean up the object URL after the download
                    URL.revokeObjectURL(objectURL);
                })
                .catch(error => {
                    setDownloadError(true);
                    console.error("Download error:", error);
                });
        } else {
            alert("No file available for download.");
        }

    };

    const handleOpenFile = () => {
        if (contract?.attachment?.filePath) {
            const fullPath = `${baseURL}/Upload${contract.attachment.filePath}`;
            window.open(fullPath, "_blank");
        }
    };

    const handleBack = () => {
        window.scrollTo(0, 0);
        navigate("/my-account/contracts");
    };
    const getFileIcon = (filePath) => {
        const fileExtension = filePath?.split('.').pop().toLowerCase();

        switch (fileExtension) {
            case 'pdf':
                return <img src={pdf} alt="PDF Icon" width={60} height={60} loading="lazy" />;
            case 'doc':
            case 'docx':
                return <img src={word} alt="Word Icon" width={60} height={60} loading="lazy" />;
            default:
                return <img src={`${baseURL}/Upload${filePath}`} alt=" File Icon" width={65} height={65} style={{ borderRadius: "50%", }} loading="lazy" />;
        }
    };
    if (loading) return <Loading />;
    return (
        <Box sx={{ padding: "28px auto" }}>
            {/* Contract Information */}
            <Card sx={{ boxShadow: "0px 4px 6px 0px #3E49540A", mb: 3, borderRadius: "12px" }}>
                <CardContent sx={{ padding: "32px" }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontSize: "20px",
                            lineHeight: "32.74px",
                        }}
                    >
                        {t.ContractInformation}
                    </Typography>
                    <Grid
                        container
                        spacing={3}
                        mt={2}
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent="space-between"
                    >
                        {[
                            {
                                icon: getFileIcon(contract?.attachment?.filePath),
                                label: t.ContractName,
                                value: title,
                            },
                            {
                                icon: <CalendarMonthIcon fontSize="small" sx={{ color: "#12538B" }} />,
                                label: t.StartDate,
                                value: startDate2,
                            },
                            {
                                icon: <CalendarMonthIcon fontSize="small" sx={{ color: "#12538B" }} />,
                                label: t.EndDate,
                                value: endDate2,
                            },
                            {
                                icon: <LocalOfferIcon fontSize="small" sx={{ color: "#12538B" }} />,
                                label: t.TotalPrice,
                                value: `$${totalPrice}`,
                            }
                        ].map((item, index) => (
                            <Grid
                                item
                                xs={12} sm={6} md={3} // For small screens, show 2 per row; for medium and large screens, show 3 per row
                                key={index}
                            >
                                <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                    <Box
                                        sx={{
                                            width: "36px",
                                            height: "36px",
                                            backgroundColor: "#F3F0FF",
                                            borderRadius: "50%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            ml: direction === "ltr" ? "" : 2, mr: direction === "rtl" ? "" : 2
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Box ml={2}>
                                        <Typography variant="body2" color="textSecondary">
                                            {item.label}
                                        </Typography>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                            {item.value}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </Card>


            {/* Contract Description */}
            <Card sx={{ boxShadow: "0px 4px 6px 0px #3E49540A", mb: 3, borderRadius: "12px" }}>
                <CardContent sx={{ padding: "32px" }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontSize: "20px",
                            lineHeight: "32.74px",
                        }}
                    >
                        {t.ContractDescription}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 400,
                            fontSize: "16px",
                            lineHeight: "21.82px",
                            mt: 2,
                        }}
                    >
                        {contract?.contractDescription || "NULL"}
                    </Typography>
                </CardContent>
            </Card>

            {/* Unit Information */}
            <Card sx={{ boxShadow: "0px 4px 6px 0px #3E49540A", mb: 3, borderRadius: "12px" }}>
                <CardContent sx={{ padding: "32px" }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontSize: "20px",
                            lineHeight: "32.74px",
                        }}
                    >
                        {t.UnitInformation}
                    </Typography>
                    <Grid container spacing={2} mt={2}>
                        {unitInfo.map((unit, index) => (
                            <Grid
                                container
                                key={index}
                                sx={{
                                    padding: "16px",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    marginBottom: 2,
                                }}
                            >
                                {[
                                    { label: t.unitName, value: unit.name },
                                    { label: t.description2, value: unit.description },
                                    { label: t.project, value: unit.project },
                                    { label: t.building, value: unit.building },
                                    { label: t.floor, value: unit.floor },
                                    { label: t.status, value: unit.status },
                                ].map((item, index) => (
                                    <Box ml={2} flex={1} key={index}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: 500,
                                                lineHeight: "24px",
                                                color: "#000",
                                                marginBottom: "32px",
                                            }}
                                        >
                                            {item.label}
                                        </Typography>

                                        {/* Conditional rendering for status */}
                                        {item.label === t.status ? (
                                            <Chip
                                                label={
                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                        <GoDotFill
                                                            style={{
                                                                fontSize: "10px",
                                                                color:
                                                                    unit.status === "Active"
                                                                        ? "#209F84"
                                                                        : "#FF2C53", // Active is green, Stopped is red

                                                            }}
                                                        />
                                                        {unit.status === "Active" ? t.active : t.inactive} {/* Customize the label */}
                                                    </Box>
                                                }
                                                sx={{
                                                    backgroundColor:
                                                        unit.status === "Active"
                                                            ? "#209F841A"
                                                            : "#F3E9E8",
                                                    color: unit.status === "Active" ? "#209F84" : "#FF2C53",
                                                    fontWeight: "bold",
                                                    borderRadius: "8px",
                                                    padding: "8px 12px",
                                                }}
                                            />
                                        ) : (
                                            <Typography
                                                variant="subtitle1"
                                                sx={{
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: "21px",
                                                    color: "#3E4954",
                                                }}
                                            >
                                                {item.value}
                                            </Typography>
                                        )}
                                    </Box>
                                ))}
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </Card>

            {/* Attached File */}
            <Card sx={{ boxShadow: "0px 4px 6px 0px #3E49540A", mb: 3, borderRadius: "12px" }}>
                <CardContent sx={{ padding: "32px" }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "20px", mb: 2 }}>
                        {t.AttachedFile}
                    </Typography>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        p={2}
                        sx={{
                            backgroundColor: "#F7F8F9", borderRadius: "8px",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: 2, sm: 0 },
                        }}
                    >
                        <Typography variant="body1" sx={{
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                        }} onClick={handleOpenFile}>{contract?.attachment?.fileName}</Typography>
                        <Box sx={{ display: "flex", justifyContent: "center", }}>
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: "#12538B", color: "#fff", mr: direction === "ltr" ? 2 : "", ml: direction === "rtl" ? 2 : "" }}
                                onClick={handleDownload}
                            >
                                {t.download}
                            </Button>
                            <Button variant="outlined" sx={{ backgroundColor: "#fff", color: "#12538B" }} onClick={handleBack}  >
                                {t.back}
                            </Button>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Box>

    );
};

export default ContractDetails;
